module.exports = __webpack_public_path__ + "static/media/buying-large.d683925e.jpg";